"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getCloudUITea: ()=>external_get_cloud_ui_tea_js_namespaceObject.getCloudUITea,
    CnCloudUITeaFnName: ()=>external_get_cloud_ui_tea_js_namespaceObject.CnCloudUITeaFnName,
    VaCloudUITeaFnName: ()=>external_get_cloud_ui_tea_js_namespaceObject.VaCloudUITeaFnName
});
const external_get_cloud_ui_tea_js_namespaceObject = require("./get-cloud-ui-tea.js");
exports.CnCloudUITeaFnName = __webpack_exports__.CnCloudUITeaFnName;
exports.VaCloudUITeaFnName = __webpack_exports__.VaCloudUITeaFnName;
exports.getCloudUITea = __webpack_exports__.getCloudUITea;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CnCloudUITeaFnName",
    "VaCloudUITeaFnName",
    "getCloudUITea"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
